<template>
<div class="animated fadeIn" style="padding-bottom:10px;" :id="id">
  <resize-observer @notify="handleResize" />
  <b-row>
    <b-col sm="12" style="padding-top:20px;padding-bottom:10px;">
      <div style="font-size:18px;font-weight:600;">
        {{index+1}}. {{resultData.media_type}} / {{resultData.media}} / {{resultData.channel}} / {{resultData.vehicle}}
      </div>
    </b-col>
  </b-row>
  <b-row >
    <b-col sm="5">
      <table  :id="tableId"
              data-search="false"
              data-show-columns="false"
              data-pagination="false"
              data-detail-view="false"
              data-detail-formatter="detailFormatter"
              >
          <thead>
              <tr>
                  <th data-field="budget">Budget</th>
                  <th data-field="eImp">Impression</th>
                  <th data-field="grps">GRPs</th>
                  <th data-field="reachN">Reach(N)</th>
                  <th data-field="reach1">Reach(%)</th>
                  <th data-field="af">A.freq</th>
              </tr>
          </thead>
      </table>
    </b-col>
    <b-col sm="7" >
      <b-row>
        <b-col sm="12" style="margin-bottom:20px;">
          <div :id="reachCurveChartId" class="CSSAnimationChart"></div>
        </b-col>
        <!-- ///////////////////////////////////////////////// -->
        <b-col sm="4">
          <b-col sm="12">
            <div style="margin-bottom:15px;text-align:center;padding:5px 0px 5px 0px;" class="bg-primary">
              <b>모델 테스트(Reach)</b>
            </div>
          </b-col>
          <b-col sm="12">
            <b-row>
              <b-col sm="6">
                <select class="form-control" v-model="selectedGRPs">
                    <option value="grps" selected>GRPs</option>
                    <option value="impression">Impression</option>
                </select>
              </b-col>
              <b-col sm="6">
                <div class="modelTestLabel">
                  Reach 1+(%)
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12">
            <b-row>
              <b-col sm="6">
                <b-form-input class="bg-light" min=0 v-model="insertedGRPsStr" type="text" ></b-form-input>
              </b-col>
              <b-col sm="6">
                <div class="bg-light modelTestLabel">
                  {{testReach}}
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-col>
        <!-- ///////////////////////////////////////////////// -->
        <b-col sm="8">
          <b-col sm="12">
            <div style="margin-bottom:15px;text-align:center;padding:5px 0px 5px 0px;" class="bg-primary">
              <b>모델 세부 테스트(금액)</b>
            </div>
          </b-col>
          <b-col sm="12">
            <b-row>
              <b-col sm="3">
                <select class="form-control" v-model="selectedReach">
                    <option value="reach" selected>Reach</option>
                    <option value="reachN">도달자 수</option>
                </select>
              </b-col>
              <b-col sm="3">
                <div class="modelTestLabel">
                  필요 GRPs
                </div>
              </b-col>
              <b-col sm="2" style="padding-right:0px;">
                <select class="form-control" v-model="selectedCPM">
                    <option value="cpm" selected>CPM</option>
                    <option value="cprp">CPRP</option>
                </select>
              </b-col>
              <b-col sm="4">
                <div class="modelTestLabel">
                  필요금액
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12">
            <b-row>
              <b-col sm="3">
                <b-form-input class="bg-light" min=0 v-model="insertedReachStr" type="text" ></b-form-input>
              </b-col>
              <b-col sm="3">
                <div class="bg-light modelTestLabel">
                  {{testGRPs}}
                </div>
              </b-col>
              <b-col sm="2" style="padding-right:0px;">
                <b-form-input class="bg-light" min=0 v-model="insertedCPMStr" type="text" ></b-form-input>
              </b-col>
              <b-col sm="4">
                <div class="bg-light modelTestLabel">
                  {{testBudget}}
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</div>
</template>
<style src="bootstrap-table/dist/bootstrap-table.min.css"></style>
<script>
import Vue from 'vue'
import VueResize from 'vue-resize'
Vue.use(VueResize)

import reachCurveFormData from "../common/ReachCurveFormData.js";
import reachFormData from "../common/ReachFormData.js";
import bootstrapTable from "bootstrap-table";
import numeral from 'numeral';

import amchart from "../../custom/amcharts/amcharts.js";
import serial from "../../custom/amcharts/serial.js";
import reachCurveChart from "./ReachCurveChart.js";

export default {
  filters:{
    thousands : function (value) {
      return numeral(value).format('0,0');
    }
  },
  // DateRangePicker
  components: {

  },
  props: {
    resultListData:null,
    mediaResultDataList:null,
    index:0,
  },
  data() {
    return {
      id: null,
      // {{index+1}}. {{resultData.media_type}} / {{resultData.media}} / {{resultData.channel}} / {{resultData.vehicle}}
      resultData: {
        media_type:'',
        media : '',
        channel : '',
        vehicle : ''
      },
      resultCffnt: null,
      mediaResult: [],
      mediaListResult: [],
      tableId:'',
      reachCurveChartId:null,
      bulletIndex:0,
      selectedGRPs:'grps',
      selectedReach:'reach',
      selectedCPM: 'cpm',
      insertedGRPsStr: 0,
      insertedGRPs:0,
      insertedReachStr: 0,
      insertedReach:0,
      insertedCPMStr: 0,
      insertedCPM:0,
      testReach:0.0,
      testGRPs:0.0,
      testBudget:0,

    }
  },
  beforeCreate: function() {},
  watch: {
    'insertedGRPsStr': function(){

      if(this.selectedGRPs == 'grps'){

        this.insertedGRPs = numeral(this.insertedGRPsStr).format('0.00');

        var TA = -1 * (Math.log(this.insertedGRPs) * this.resultCffnt.b1 + this.resultCffnt.a);
        var AA = 1 + Math.exp(TA);
        this.testReach = this.resultCffnt.lmt / AA * 100;
        this.testReach = this.testReach.toFixed(2);
      }else{

        this.insertedGRPsStr = numeral(this.insertedGRPsStr).format('0,0');
        this.insertedGRPs = numeral(this.insertedGRPsStr).format('0');

        var TA = -1 * (Math.log(this.insertedGRPs / this.resultCffnt.population * 100) * this.resultCffnt.b1 + this.resultCffnt.a);
        var AA = 1 + Math.exp(TA);
        this.testReach = this.resultCffnt.lmt / AA * 100;
        this.testReach = this.testReach.toFixed(2);
      }
    },
    'insertedReachStr': function(){

      if(this.selectedReach == 'reach'){

        this.insertedReach = numeral(this.insertedReachStr).format('0.00');

        var reach = this.insertedReach / 100;
        var TA = this.resultCffnt.lmt/reach - 1;
        var AA = Math.log((TA))
        var BB = -1 * (this.resultCffnt.a + AA);
        var CC = Math.exp(BB/this.resultCffnt.b1);
        this.testGRPs = CC.toFixed(2);
      }else{
        this.insertedReachStr = numeral(this.insertedReachStr).format('0,0');
        this.insertedReach = numeral(this.insertedReachStr).format('0');

        var reach = this.insertedReach / this.resultCffnt.population;
        var TA = this.resultCffnt.lmt/reach - 1;
        var AA = Math.log((TA))
        var BB = -1 * (this.resultCffnt.a + AA);
        var CC = Math.exp(BB/this.resultCffnt.b1);
        this.testGRPs = CC.toFixed(2);
      }
    },
    'insertedCPMStr': function(){

      this.insertedCPMStr = numeral(this.insertedCPMStr).format('0,0');
      this.insertedCPM = numeral(this.insertedCPMStr).format('0');

      if(this.selectedCPM == 'cpm'){
        this.testBudget = (this.testGRPs/100 * this.resultCffnt.population)/1000 * this.insertedCPM;
        this.testBudget = numeral(this.testBudget).format('0,0');
      }else{
        this.testBudget = this.testGRPs * this.insertedCPM
        this.testBudget = numeral(this.testBudget).format('0,0');
      }
    }
  },
  created: function() {
    this.id = this._uid + '_';
    this.tableId = this.id + 'table';
    this.reachCurveChartId = this.id + 'div';

  },
  mounted: function() {
    this.resultListData[this.index].target = this.resultListData[this.index].targetCode;
    this.resultData = this.$_.clone(this.resultListData[this.index]);
    this.mediaResult.push(this.resultListData[this.index]);

    var token = sessionStorage.getItem("myToken");
    var param = encodeURI(JSON.stringify(this.mediaResult));
    // var param = JSON.stringify(this.mediaResult);
    var data = new FormData();
    data.append('objs', param);
    var config = {
      onUploadProgress: function(progressEvent) {
        var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
      }
    };

    this.$http.post('/api/select/cffcntData?access_token='+token, data, config)
        .then((result) => {
          this.resultCffnt = this.$_.clone(result.data[0]);
          var unitVal = this.resultData.unit;
          this.resultData.minNumber = parseInt(this.resultData.minNumber);
          this.resultData.maxNumber = parseInt(this.resultData.maxNumber);
          for(var i=0; i< this.resultData.maxNumber ; i++){
            var tmp = this.$_.clone(result.data[0]);
            tmp.budget = (this.resultData.minNumber + i) * unitVal;

            if(unitVal == 1000000){
              tmp.budgetStr =  (this.resultData.minNumber + i) + '백만';
            }else if(unitVal == 10000000){
              tmp.budgetStr =  (this.resultData.minNumber + i) + '천만';
            }else if(unitVal == 100000000){
              tmp.budgetStr =  (this.resultData.minNumber + i) + '억';
            }

            if(this.resultData.cpmUnit == 'cpm'){
              tmp.eImp = ((tmp.budget) / tmp.cpm ) * 1000;
              tmp.grps = (tmp.eImp / tmp.population) * 100;
            }else if(this.resultData.cpmUnit == 'cprp'){
              tmp.grps = tmp.budget / tmp.cpm;
              tmp.eImp = (tmp.population * tmp.grps) / 100
            }
            tmp.rowId = (i);
            tmp.bulletSize = 1;
            tmp.bullet = null;
            tmp.reach1 = this.inputLevelCalc(tmp, tmp.grps);
            tmp.reachN = tmp.population * tmp.reach1 / 100;
            tmp.af = tmp.grps/tmp.reach1;
            if(tmp.reach1 <1.1){
              tmp.reach1ForChart = 1.1; // 임시코드
            }else{
              tmp.reach1ForChart = tmp.reach1.toFixed(2);
            }
            // 포매팅
            tmp.budget = numeral(tmp.budget).format('0,0');
            tmp.eImp = numeral(tmp.eImp.toFixed(0)).format('0,0');
            tmp.grps = tmp.grps.toFixed(2);
            tmp.reachN = numeral(tmp.reachN.toFixed(0)).format('0,0');
            tmp.reach1 = tmp.reach1.toFixed(2);
            tmp.af = tmp.af.toFixed(2);
            this.mediaListResult.push(tmp);
          }
          // this.mediaResultDataList.push(this.mediaListResult);
          this.mediaResultDataList[this.index] = this.mediaListResult;
          this.changeBullet(0);
          var self = this;
          $(function () {
              $('#'+self.tableId).bootstrapTable({
                  height : 450,
                  data: self.mediaListResult,
                  onClickRow: function (row, $element) {
                    $($element).addClass('selectedActive').siblings().removeClass('selectedActive');
                    self.changeBullet((row.rowId));
                  },
              });
              var first = $('#'+self.tableId + " > tbody tr:first")
              $(first).addClass('selectedActive').siblings().removeClass('selectedActive');
          });
    })
  },
  updated: function() {
  },
  methods: {
    deleteThis() {
      $("#" + this.id).fadeOut('slow', function() {
        document.getElementById(this.id).remove();
      });
    },
    handleResize() {
      $('#'+this.tableId).bootstrapTable('resetView');
    },
    inputLevelCalc(cffcnt, grps){ // 공통파일로 대체 필요
      var z = (
        cffcnt.a +
        cffcnt.b1 * Math.log(grps) +
        cffcnt.b2 * Math.pow(Math.log(grps),2) +
        cffcnt.b3 * Math.pow(Math.log(grps),3)
      );
      var z2 = 1 + Math.exp(-z);
      var result = (cffcnt.lmt/z2) * 100;
      if(isNaN(result)){ // 여기에 넣기에는 너무 부담스럽지 않을까?
        result = 0;
      }
      return result;
    },
    changeBullet(newBulletIndex){
      this.mediaListResult[this.bulletIndex].bulletSize = 1;
      this.mediaListResult[this.bulletIndex].bullet = null;
      this.bulletIndex = newBulletIndex;
      this.mediaListResult[this.bulletIndex].bulletSize = 10;
      this.mediaListResult[this.bulletIndex].bullet = 'square';
      reachCurveChart.drawChart(this.mediaListResult, 1, this.reachCurveChartId);
    }
  }
}
</script>
<style src="../../custom/amcharts/amchart_plugins.min.css"></style>
<style scoped>
.CSSAnimationChart,
.mapChart {
    width: 100%;
    height: 300px
}
.modelTestLabel {
  margin-bottom:5px;
  padding:6px 0px 6px 0px;
  font-weight:600;
  color:black;
  border: 1px solid #c2cfd6;
}
</style>
<style>
</style>



// WEBPACK FOOTER //
// src/views/reachCurve/ReachCurveResult.vue